import zappy from "@zappy-ride/library.react.components";
import { FormOutputVehicleEditModal } from "./FormOutputVehicleEditModal";

export * from "./FormOutputVehicleEditModal";

zappy.FactoryInstance.registerComponent(FormOutputVehicleEditModal);
